import React from "react";
import {
  Autocomplete,
  Box,
  Checkbox,
  CheckBoxIcon,
  CheckBoxOutlineBlankIcon,
  ListItem,
  TextField,
} from "../../platform-style";

interface AutocompleteMultiSelectSearchBoxProps {
  id: string;
  name: string;
  label: string;
  width?: string;
  setFieldName: (value: string) => void;
  options: { key: string; name?: string; optionValue: string }[];
  setOffset?: (value: any) => void;
  placeholder?: string;
  loading?: boolean;
  hasError?: boolean;
  helperText?: string;
  value?: { key: string; name?: string; optionValue: string }[];
  handleChange?: (event: any, value: { key: string; name?: string; optionValue: string }[]) => void;
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const AutocompleteMultiSelectSearchBox = (props: AutocompleteMultiSelectSearchBoxProps) => {
  return (
    <>
      <Autocomplete
        sx={{
          width: props.width ? props.width : "300px",
          "&.Mui-expanded": {
            zIndex: 9999,
            maxHeight: { xs: "100px", md: "180px" },
            overflow: "auto",
          },
        }}
        multiple
        limitTags={2}
        disableCloseOnSelect
        noOptionsText="No search results found."
        options={props.options}
        value={props.value}
        onChange={props.handleChange}
        loading={props.loading}
        loadingText="Loading…"
        getOptionLabel={(option) => (typeof option === "string" ? option : option.optionValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            id={props.id}
            name={props.name}
            label={props.label}
            placeholder={props.placeholder}
            error={props.hasError ? props.hasError : false}
            helperText={props.helperText ? props.helperText : ""}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              ...params.InputProps,
            }}
          />
        )}
        renderOption={(renderProps, option, { selected }) => {
          return (
            <ListItem {...renderProps}>
              <Box>
                <Checkbox
                  role="checkbox"
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={
                    props.value && props.value.length > 0
                      ? props.value.filter((obj) => obj.key === option.key).length !== 0
                      : selected
                  }
                />
                {option.optionValue}
              </Box>
            </ListItem>
          );
        }}
      ></Autocomplete>
    </>
  );
};
